import axios from 'axios';
import toast from 'react-hot-toast';
import * as rax from 'retry-axios';

import config from '../redux/actions/config';

const interceptorId = rax.attach();

export default async function getPlateVinInfo(search) {
	var vehicle = null;
	var errorAxios = null;

	const apiPath = config.apiUrl;

	await axios
		.post(
			`${apiPath}/licenseplatevin/`, // TODO: Make GoogleData an options later.. but for now test and build away
			search,
			{ crossdomain: true }
		)
		.then(response => {
			vehicle = response.data;
			if (response.data.name === 'Error') {
				toast.error('Error Looking up License Plate or VIN');
			}
		})
		.catch(error => {
			toast.error('Error Looking up License Plate or VIN');
			errorAxios = error;
		});
	return { vehicle: vehicle, error: errorAxios };
}
